

import React from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'
import sidephone from '../Images/sidephone.png'



const Security = () => {



  return (
    <div>
            <Newnavbar />

                    <div className="bg-[#FFFDF5] min-h-screen px-4 md:px-12 py-12 text-[#1F1F1F] font-sans">
                        <div className="max-w-4xl mx-auto">
                            <div className='trust_below_des flex justify-center items-center'>
                        <p className="md:!text-[48px] md:py-[48px] py-[20px]  !text-[24px] !font-bold !text-gray-900 ">
                          Security at PayBi
                        </p>
                        </div>

                            <div className="space-y-10 text-[16px] leading-relaxed">
                            <div>
                                <h2 className="font-semibold text-lg">1. Data Encryption</h2>
                                <p>
                                All data transmitted between your device and our servers is encrypted using industry-standard SSL/TLS protocols.
                                We also encrypt sensitive data at rest.
                                </p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-lg">2. Secure Authentication</h2>
                                <p>
                                We use multi-factor authentication (MFA) and strong password policies to prevent unauthorized access.
                                </p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-lg">3. Fraud Monitoring</h2>
                                <p>
                                Our systems continuously monitor transactions and user activity for suspicious behavior.
                                Any irregularity is flagged and reviewed immediately.
                                </p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-lg">4. Regular Security Audits</h2>
                                <p>
                                We perform frequent internal security reviews, code audits, and third-party penetration testing to stay ahead of threats.
                                </p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-lg">5. Compliance & Standards</h2>
                                <p>
                                PayBi complies with global data protection laws including GDPR and follows best practices based on ISO 27001 and PCI-DSS where applicable.
                                </p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-lg">6. Your Responsibility</h2>
                                <p>
                                We encourage users to maintain good cyber hygiene:
                                </p>
                                <ul className="list-disc ml-6 mt-2 space-y-1">
                                <li>Use strong, unique passwords</li>
                                <li>Never share your credentials</li>
                                <li>Regularly review your transaction history</li>
                                </ul>
                            </div>
                            </div>
                        </div>
                    </div>

            <Newfooter />
      
    </div>
  )
}

export default Security


